var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 269,
    viewBox: "0 0 324 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_1808_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.379 193.111C210.382 227.295 90.1016 225.67 46.7072 139.549C3.31287 53.4277 61.5549 19.093 121.312 29.3096C167.411 37.1948 184.903 40.5889 204.733 19.6555C228.042 -4.95013 285.324 -9.50684 304.069 56.7874C322.814 123.082 304.069 164.502 261.379 193.111Z",
    fill: "url(#paint0_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.884 203.583V113.69H108.289V198.386C112.413 200.303 116.611 202.035 120.884 203.583Z",
    fill: "url(#paint1_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.834 191.21C99.1862 193.834 103.677 196.225 108.287 198.374V113.677L94.8371 116.462L94.834 191.21Z",
    fill: "url(#paint2_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.139 198.529L44.9844 136.042C45.5429 137.201 46.1141 138.367 46.7074 139.548C50.5238 147.141 55.1027 154.333 60.3748 161.016L219.468 209.899C231.554 207.271 242.653 203.408 252.139 198.529Z",
    fill: "url(#paint3_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.873 150.634L106.25 110.47L44.9844 136.042L252.139 198.529C255.322 196.901 258.407 195.092 261.379 193.11C278.877 181.378 292.349 167.498 300.873 150.634Z",
    fill: "url(#paint4_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.938 179.955V139.619L274.606 147.989V192L230.938 179.955Z",
    fill: "url(#paint5_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 147.991V192.001L305.172 172.703V131.977L274.605 147.991Z",
    fill: "url(#paint6_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.173 131.976L274.606 147.99L230.938 139.62L266.884 125.431L305.173 131.976Z",
    fill: "url(#paint7_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07 142.327V156.625L254.982 158.716V144.227L245.07 142.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.982 144.227L287.632 128.978L277.527 127.25L245.07 142.327L254.982 144.227Z",
    fill: "url(#paint8_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.437 147.032L119.739 123.573L90.5898 136.187L189.727 162.49L217.437 147.032Z",
    fill: "url(#paint9_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5898 136.188L189.727 162.49V165.787L90.5898 138.422V136.188Z",
    fill: "url(#paint10_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.725 162.491V165.788L217.435 150.246V147.033L189.725 162.491Z",
    fill: "url(#paint11_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.411 89.4609H182.003V116.729C182.006 120.431 179.901 123.817 176.562 125.48L168.373 129.543V132.356L189.791 136.656C189.791 136.656 204.73 129.884 204.73 125.405L205.825 95.0396L185.411 89.4609Z",
    fill: "url(#paint12_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.821 95.0288H203.414V122.31C203.417 126.011 201.312 129.397 197.973 131.061L189.787 135.124V137.936L199.254 132.851C203.265 130.776 205.778 126.666 205.777 122.185L205.821 95.0288Z",
    fill: "url(#paint13_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.79 135.119L168.375 129.55V132.35L189.79 137.92V135.119Z",
    fill: "url(#paint14_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45 118.726L143.246 101.083C140.643 100.661 138.557 98.0862 138.557 95.3265V34.239C138.557 31.4763 140.643 29.2385 143.246 29.2385H252.45C256.552 29.2385 259.897 32.0951 259.897 35.6173V113.56C259.897 117.072 256.54 119.388 252.45 118.726Z",
    fill: "url(#paint15_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.164 118.726L140.96 101.083C138.359 100.661 136.273 98.0862 136.273 95.3265V34.239C136.273 31.4763 138.359 29.2385 140.96 29.2385H250.164C254.266 29.2385 257.614 32.0951 257.614 35.6173V113.56C257.614 117.072 254.253 119.388 250.164 118.726Z",
    fill: "url(#paint16_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.637 58.9912L248 60.4444",
    stroke: "white",
    strokeWidth: 4.24166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.637 73.3118L248 75.9901",
    stroke: "white",
    strokeWidth: 4.24166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.637 86.8975L236.627 89.5789",
    stroke: "white",
    strokeWidth: 4.24166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.426 39.6508C203.426 36.9011 201.176 34.6721 198.399 34.6721H145.986C143.802 34.6721 142.051 36.5473 142.051 38.8694V90.1246C142.051 92.4436 143.802 94.6064 145.986 94.9595L197.598 103.307C199.053 103.542 200.539 103.132 201.662 102.186C202.785 101.241 203.433 99.8543 203.433 98.3942L203.426 39.6508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4218 131.012L65.3204 145.332C65.3204 145.332 80.0987 147.13 93.4285 147.255C106.758 147.38 113.256 146.726 114.487 149.13C114.487 149.13 117.327 149.586 117.169 152.205C117.169 152.205 119.009 152.561 118.936 154.44C119.949 155.492 120.14 157.078 119.406 158.337C118.16 160.584 115.746 164.9 115.086 164.119C114.427 163.337 115.594 159.456 115.594 159.456C115.594 159.456 108.765 160.631 104.492 159.396C100.22 158.162 75.5607 166.063 62.7832 165.878C50.0057 165.694 41.0781 161.859 41.0781 150.592C41.0781 139.326 43.1893 124.74 43.1893 124.74L66.4218 131.012Z",
    fill: "url(#paint17_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1032 136.92C66.1032 136.92 73.6043 100.91 67.681 93.0527C61.7578 85.1956 47.7021 82.561 44.0447 104.494C40.3872 126.428 40.1726 134.313 42.3753 136.223C45.8497 139.226 60.871 142.677 66.1032 136.92Z",
    fill: "url(#paint18_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6602 168.213C64.6602 168.213 107.004 163.525 123.167 162.487C139.331 161.45 149.748 167.447 151.326 185.486L84.4245 196.572L64.6602 168.213Z",
    fill: "url(#paint19_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4103 179.91C53.4103 179.91 49.0649 204.729 71.1802 213.895C92.8632 222.884 126.891 226.259 152.913 203.525L155.618 212.117C155.618 212.117 172.47 214.736 188.699 213.751C188.699 213.751 186.333 191.44 179.586 179.91C177.263 175.941 169.636 167.447 149.553 170.966C144.333 171.882 122.445 178.095 122.445 178.095C119.059 178.129 78.7224 168.006 75.4499 167.622C55.4489 165.278 53.4103 179.91 53.4103 179.91Z",
    fill: "url(#paint20_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7852 78.6312C79.8937 73.6667 80.79 68.2797 80.4013 62.9077H104.413C104.413 62.9077 102.28 73.4807 109.213 80.7783C109.213 80.7783 87.407 87.6665 77.7852 78.6312Z",
    fill: "url(#paint21_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9423 161.601C54.9276 128.438 50.0836 113.84 47.7641 105.304C45.4447 96.7692 46.0253 91.453 58.9575 84.8086C71.8896 78.1642 70.8388 78.6423 70.8388 78.6423L114.823 82.799C114.823 82.799 135.894 89.8028 138.917 97.6818C140.287 101.263 128.917 120.872 128.917 144.183C128.917 168.911 133.625 184.528 131.041 187.313C124.287 194.582 57.3575 194.145 51.2796 183.603C49.1747 179.946 50.5348 177.318 51.9423 161.601Z",
    fill: "url(#paint22_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5176 79.894C68.5176 79.894 75.618 75.4969 76.8676 75.0531C78.1173 74.6093 83.6682 78.5158 94.991 77.6939C105.563 76.9251 105.683 75.1656 107.077 76.0219C109.643 77.6001 114.822 82.7973 114.822 82.7973C114.822 82.7973 86.3316 92.9042 68.5176 79.894Z",
    fill: "url(#paint23_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.308 36.7738C115.968 39.863 116.39 42.9974 116.571 46.1498C116.634 47.278 121.336 48.8751 118.556 51.4441C117.609 52.3098 116.593 52.2379 116.466 53.5318C115.693 61.4701 116.451 73.0869 105.964 71.1524C105.964 71.1524 87.661 66.4456 84.2844 62.9671C75.8239 54.2381 78.5473 39.3304 83.1704 32.6516C89.646 23.3412 111.812 23.8444 115.308 36.7738Z",
    fill: "url(#paint24_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.307 61.3018C100.718 60.1662 100.3 58.8992 99.2911 58.2233C97.2967 56.8701 94.4502 54.0948 95.2896 49.635C96.5519 42.9468 103.826 42.4092 106.284 47.8535L110.134 47.9598C110.134 47.9598 109.307 41.6216 113.564 38.8557C117.822 36.0898 123.767 32.2926 122.331 29.3704C120.895 26.4482 118.333 26.3232 118.333 26.3232C118.333 26.3232 113.826 20.8226 106.994 20.5195C100.162 20.2163 97.9215 19.4662 91.1051 19.8038C84.2888 20.1413 79.4795 24.5824 79.6783 30.0361C79.6783 30.0361 70.6939 29.7548 69.5799 42.3655C68.466 54.9761 79.3627 68.1837 79.3627 68.1837C79.3627 68.1837 86.1286 72.8373 95.6652 70.4902C96.5386 70.2808 97.2488 69.6536 97.5586 68.8182L100.307 61.3018Z",
    fill: "url(#paint25_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7207 49.2971C98.7207 49.2971 102.927 49.2971 103.71 53.6568",
    stroke: "#382824",
    strokeWidth: 1.69666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.98,
    cy: 57.9693,
    rx: 2.66974,
    ry: 2.64391,
    fill: "url(#paint26_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.248 132.463L150.126 146.527C150.126 146.527 164.842 144.267 177.701 140.789C190.561 137.311 196.636 134.935 198.478 136.914C198.478 136.914 201.319 136.601 201.906 139.148C201.906 139.148 203.771 138.995 204.222 140.82C205.485 141.559 206.105 143.034 205.743 144.442C205.162 146.943 204.023 151.734 203.177 151.174C202.332 150.615 202.385 146.549 202.385 146.549C202.385 146.549 196.134 149.521 191.684 149.487C187.235 149.452 165.678 163.698 153.339 166.989C141 170.279 131.337 168.979 128.257 158.131C125.177 147.283 123.18 132.685 123.18 132.685L147.248 132.463Z",
    fill: "url(#paint27_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.075 138.408C150.075 138.408 145.881 101.564 138.033 95.5911C130.185 89.6187 115.902 90.9032 118.423 112.974C120.945 135.045 122.898 142.712 125.546 143.955C129.715 145.918 147.57 143.205 150.075 138.408Z",
    fill: "url(#paint28_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.814 140.569L151.339 154.954",
    stroke: "white",
    strokeWidth: 1.69666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.027 218.257C132.027 218.257 88.4054 142.312 79.9481 135.467C68.6064 126.291 15.5713 113.953 13.0877 127.029C11.3804 136.033 36.8535 203.19 45.7715 210.328C62.1214 223.417 132.27 231.433 132.027 218.257Z",
    fill: "url(#paint29_linear_1808_3099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.012 211.884C165.489 202.118 167.301 192.223 167.301 192.223L139.792 206.79C133.702 210.017 126.124 207.874 122.672 201.949C111.713 183.162 89.2438 145.193 80.8338 135.436C66.2733 118.506 15.5544 113.962 13.0804 127.026C13.0197 127.385 12.9933 127.749 13.0015 128.113C13.6326 127.535 14.491 127.519 15.5544 127.532C24.8544 127.622 56.1592 129.094 68.5138 142.736C75.6142 150.569 101.621 200.07 114.338 224.932C130.423 224.41 146.088 218.629 154.012 211.884Z",
    fill: "url(#paint30_linear_1808_3099)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1808_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.512 46.999L182.121 48.7089C186.927 49.1505 190.859 53.459 190.859 58.2873V77.58C190.859 82.4063 186.927 85.9941 182.121 85.5525L163.512 83.8426C158.706 83.401 154.773 79.0905 154.773 74.2642V54.9715C154.773 50.1432 158.706 46.5574 163.512 46.999Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.785 74.611L179.847 75.9032C180.026 75.9196 180.17 76.0777 180.17 76.2572V78.0604C180.17 78.2399 180.026 78.3715 179.847 78.355L165.785 77.0629C165.606 77.0464 165.462 76.8883 165.462 76.7089V74.9057C165.462 74.7262 165.606 74.5946 165.785 74.611ZM172.587 73.1718L165.671 65.5886C165.547 65.4548 165.468 65.2945 165.435 65.1284C165.405 64.9665 165.419 64.7985 165.486 64.6414C165.553 64.4865 165.663 64.3639 165.799 64.2847C165.937 64.2056 166.099 64.1695 166.272 64.1854L169.534 64.4852V54.8633C169.534 54.6838 169.678 54.5522 169.857 54.5686L175.774 55.1123C175.951 55.1286 176.097 55.2869 176.097 55.4663V65.0882L179.359 65.388C179.532 65.4038 179.695 65.4698 179.833 65.5742C179.969 65.6786 180.079 65.8212 180.146 65.9885C180.213 66.1578 180.227 66.3285 180.196 66.4848C180.164 66.645 180.085 66.7907 179.961 66.9017L173.044 73.2138C172.918 73.3287 172.713 73.3098 172.587 73.1718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1808_3099",
    x: 0.605231,
    y: 0.862971,
    width: 323.116,
    height: 267.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.13703
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13703
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1808_3099"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.69331
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.84665
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1808_3099",
    result: "effect2_dropShadow_1808_3099"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.5236
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.12887
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1808_3099",
    result: "effect3_dropShadow_1808_3099"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.7732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.19738
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1808_3099",
    result: "effect4_dropShadow_1808_3099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1808_3099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1808_3099",
    x1: 394.186,
    y1: 280.26,
    x2: 394.186,
    y2: -55.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1808_3099",
    x1: 109.382,
    y1: 158.952,
    x2: 134.248,
    y2: 168.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1808_3099",
    x1: 7.38885,
    y1: 469.058,
    x2: 106.829,
    y2: 469.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1808_3099",
    x1: 257.992,
    y1: 254.405,
    x2: 262.107,
    y2: 156.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1808_3099",
    x1: 172.929,
    y1: 110.47,
    x2: 172.929,
    y2: 198.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FFDF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1808_3099",
    x1: 211.574,
    y1: 265.625,
    x2: 378.004,
    y2: 265.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1808_3099",
    x1: 254.223,
    y1: 278.382,
    x2: 372.764,
    y2: 278.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1808_3099",
    x1: 189.894,
    y1: 155.672,
    x2: 314.694,
    y2: 155.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1808_3099",
    x1: 284.608,
    y1: 153.051,
    x2: 289.64,
    y2: 124.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1808_3099",
    x1: 154.014,
    y1: 123.573,
    x2: 154.014,
    y2: 162.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1808_3099",
    x1: 6.55192,
    y1: 139.556,
    x2: 14.9241,
    y2: 209.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1808_3099",
    x1: 197.041,
    y1: 185.152,
    x2: 217.496,
    y2: 152.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48567D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1808_3099",
    x1: 176.56,
    y1: 64.6996,
    x2: 154.444,
    y2: 120.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1808_3099",
    x1: 174.625,
    y1: 126.202,
    x2: 203.218,
    y2: 131.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1808_3099",
    x1: 219.181,
    y1: 135.236,
    x2: 209.335,
    y2: 111.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1808_3099",
    x1: 314.334,
    y1: 48.455,
    x2: 245.037,
    y2: 48.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A4A6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1808_3099",
    x1: 131.606,
    y1: 135.451,
    x2: 297.938,
    y2: 135.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1808_3099",
    x1: 152.226,
    y1: 113.382,
    x2: 29.9637,
    y2: 113.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1808_3099",
    x1: 55.4569,
    y1: 87.3496,
    x2: 55.4569,
    y2: 140.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1808_3099",
    x1: 15.0268,
    y1: 170.602,
    x2: 19.3429,
    y2: 242.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1808_3099",
    x1: 120.882,
    y1: 167.367,
    x2: 120.882,
    y2: 220.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1808_3099",
    x1: 68.3401,
    y1: 85.4316,
    x2: 106.37,
    y2: 85.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1808_3099",
    x1: 92.8684,
    y1: 78.6348,
    x2: 92.8684,
    y2: 192.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1808_3099",
    x1: 91.6696,
    y1: 75.0178,
    x2: 91.6696,
    y2: 86.5385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1808_3099",
    x1: 118.9,
    y1: 73.3526,
    x2: 118.9,
    y2: 29.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1808_3099",
    x1: 119.119,
    y1: -3.33817,
    x2: 18.5077,
    y2: -3.33817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1808_3099",
    x1: 99.7108,
    y1: 34.6336,
    x2: 99.7108,
    y2: 58.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1808_3099",
    x1: 229.624,
    y1: 103.215,
    x2: 91.4679,
    y2: 173.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1808_3099",
    x1: 134.102,
    y1: 92.53,
    x2: 134.102,
    y2: 144.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1808_3099",
    x1: 74.8915,
    y1: 242.311,
    x2: 114.936,
    y2: 171.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1808_3099",
    x1: 157.906,
    y1: 104.658,
    x2: -39.7023,
    y2: 104.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1808_3099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.844,
    height: 36.844,
    fill: "white",
    transform: "matrix(0.995805 0.0915016 0 1 154.471 46.168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.2c6443d9342f91bd2eeddd8704ac2d31.svg";
export { ForwardRef as ReactComponent };